import { Paper, styled } from '@mui/material';
import MediaTypography from 'components/MediaTypography';

export const CertificateItemWrap = styled(Paper)(() => ({
	boxShadow: '0px 0px 30px 0px #827D8326',
	borderRadius: '30px',
	padding: '16px',
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
	transition: 'all .3s',

	'&:hover': {
		boxShadow: '0px 0px 10px 0px #827D8340',
	},
}));

export const CertificateItemImage = styled('img')({
	maxWidth: '100%',
	width: '100%',
	objectFit: 'contain',
	borderRadius: '20px',
	aspectRatio: '16 / 9',
});

export const CertificateItemInfo = styled('div')({
	display: 'flex',
	flexDirection: 'column',
});

export const CertificateItemInfoTitle = styled(MediaTypography)(() => ({
	transition: 'all .3s',

	marginTop: '4px',
}));
